import ContentLoader from 'react-content-loader';

const TableSkeleton = () => {
	return (
		<ContentLoader viewBox="0 0 400 150">
			<rect x="0" y="0" width="400" height="10" rx="3"></rect>
			<rect x="0" y="20" width="400" height="10" rx="3"></rect>

			<rect x="0" y="10" width="20" height="10" rx="1"></rect>
			<rect x="40" y="10" width="160" height="10" rx="1"></rect>
			<rect x="260" y="10" width="70" height="10" rx="1"></rect>
			<rect x="360" y="10" width="40" height="10" rx="1"></rect>

			<rect x="0" y="138" width="400" height="2" rx="3"></rect>

			<rect x="0" y="0" width="2" height="140" rx="3"></rect>
			<rect x="398" y="0" width="2" height="140" rx="3"></rect>

			<rect x="15" y="40" width="30" height="30" rx="3"></rect>

			<rect x="55" y="40" width="80" height="10" rx="3"></rect>
			<rect x="55" y="55" width="100" height="10" rx="3"></rect>
			<rect x="55" y="70" width="50" height="10" rx="3"></rect>

			<rect x="200" y="40" width="80" height="10" rx="3"></rect>

			<rect x="330" y="40" width="50" height="10" rx="3"></rect>

			<rect x="15" y="90" width="30" height="30" rx="3"></rect>

			<rect x="55" y="90" width="80" height="10" rx="3"></rect>
			<rect x="55" y="105" width="100" height="10" rx="3"></rect>
			<rect x="55" y="120" width="50" height="10" rx="3"></rect>

			<rect x="200" y="90" width="80" height="10" rx="3"></rect>

			<rect x="330" y="90" width="50" height="10" rx="3"></rect>
		</ContentLoader>
	);
};

export default TableSkeleton;
